import React from 'react';
import { useConfig } from '@ynap/immutables-provider';
import { Link } from 'react-router-dom';

const linkRenderer = (
    urlConfig = {},
    internal_urls = [],
    locale = '',
    href,
    children,
    onClickFn = () => {},
    className = '',
    reloadPage = false,
    hostnameOverride,
) => {
    const hostname = hostnameOverride || useConfig()?.head?.seo?.baseUrl;
    const urlRegex = /^([a-zA-Z]{3,5}:\/{2})*([a-zA-Z0-9_:-]+\.)*[a-zA-Z0-9_:-]+\.[a-zA-Z0-9_:-]+/;
    const isAbsoluteUrl = href.search(urlRegex) > -1;
    const hrefHasAppHostname = hostname && href.search(hostname) > -1;

    if (isAbsoluteUrl && (!hrefHasAppHostname || reloadPage)) {
        return (
            <a href={href} onClick={onClickFn} className={className} target={reloadPage ? '_self' : '_blank'} rel="noopener noreferrer">
                {children}
            </a>
        );
    }

    const localeRegex = /^\/(?<locale>[a-z]{2}-[a-z]{2})(?<path>\/.*)/;
    const relativeUrl = href.replace(urlRegex, '');
    const unlocalisedUrl = relativeUrl.match(localeRegex)?.groups.path || relativeUrl;
    const unlocalisedFormattedUrl = unlocalisedUrl.charAt(0) !== '/' ? '/'.concat(unlocalisedUrl) : unlocalisedUrl;
    const localisedUrl = `/${locale}${unlocalisedFormattedUrl}`;
    const isSameAppLink = internal_urls.find((url) => localisedUrl.match(urlConfig[url].deconstruct.regex)?.length);

    return isSameAppLink ? (
        <Link to={localisedUrl} onClick={onClickFn} className={className}>
            {children}
        </Link>
    ) : (
        <a href={localisedUrl} onClick={onClickFn} className={className}>
            {children}
        </a>
    );
};

export { linkRenderer };
